import React from 'react';
import { Helmet } from 'react-helmet';
import { CONFIG } from 'utils/config';
import * as Styled from './BackgroundVideo.styled';

const BackgroundVideo = ({
    wistiaVideoId,
    videoWidth,
    videoHeight,
}: {
    wistiaVideoId: string;
    videoWidth: number;
    videoHeight: number;
}) => (
    <>
        <Helmet>
            <script
                src={`//${CONFIG.VITE_WISTIA_URL}/assets/external/E-v1.js`}
                async
            ></script>
            <script
                src={`https://${CONFIG.VITE_WISTIA_URL}/embed/medias/${wistiaVideoId}.jsonp`}
                async
            ></script>
        </Helmet>
        <Styled.PlayerContainer>
            <Styled.Player
                videoWidth={videoWidth}
                videoHeight={videoHeight}
                className={`wistia_embed wistia_async_${wistiaVideoId} plugin[videoThumbnail]`}
            />
        </Styled.PlayerContainer>
    </>
);

BackgroundVideo.displayName = 'Section.BackgroundVideo';

export default BackgroundVideo;
